import { render, staticRenderFns } from "./caseCard.vue?vue&type=template&id=52b0356a&lang=pug"
import script from "./caseCard.vue?vue&type=script&lang=js"
export * from "./caseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports